export const getIsOverdue = (balanceDue: number | null | undefined): boolean => {
  // Ported from web: amount > 100 and day of month between 3 and 25
  const value = Number(balanceDue || 0);
  if (!Number.isFinite(value)) return false;
  const today = new Date();
  const day = today.getDate();
  return value > 100 && day >= 3 && day <= 25;
};

export const getInCredit = (balanceDue: number | null | undefined): boolean => {
  const value = Number(balanceDue || 0);
  return Number.isFinite(value) && value < 0;
};

/** How a balance should read to the resident: owed, past due, or in their favor. */
export type BalanceStatus = 'normal' | 'overdue' | 'credit';

/**
 * The one call every balance display should make, so the home screen and the
 * payments screens never disagree about which balance is past due or a credit.
 */
export const getBalanceStatus = (balanceDue: number | null | undefined): BalanceStatus => {
  if (getInCredit(balanceDue)) return 'credit';
  if (getIsOverdue(balanceDue)) return 'overdue';
  return 'normal';
};

export const mapLeaseStatus = (status?: string): string => {
  switch ((status || '').toLowerCase()) {
    case 'current':
      return 'Current Lease';
    case 'past':
      return 'Past Lease';
    case 'future':
      return 'Future Lease';
    case 'notice':
      return 'Lease On Notice';
    default:
      return '';
  }
};


